import React from 'react';
import { images } from '../../assets/images';
import './TopBar.css';
import { Link } from 'react-router-dom';
import StoryTray from '../StoryViewer/storybuilder';

function TopBar({ onSelectRecipe }) {
  return (
    <header className="top-bar">
      <div className="top-bar-background">
        <img src={images.topBarBg} alt="" className="top-bar-bg-image" />
      </div>
      <div className="top-bar-content">
        <a href="/" className="logo-a">
          <img 
            src={images.knorrLogo} 
            alt="Knorr Logo" 
            className="logo"
          />
        </a>
      </div>
      <div><StoryTray onSelectRecipe={onSelectRecipe} /></div>
    </header>
  );
}

export default TopBar;
